<template lang="pug">
#meeting-type
  h1 Tipos de reunião

  no-show-flow
  hr

  .light-gray-text.light-text
    | Crie categorias de reuniões de acordo com o seu processo.
    br
    | As categorias te ajudam a filtrar, selecionar e analisar a efetividade das suas reuniões.

  br
  br

  new-meeting-type(@created="createdMeetingType")

  .table
    .table-body
      hr
      list-item(v-for="meeting_type in $store.getters.meetingTypesList",
                :meeting_type="meeting_type",
                :key="meeting_type.id",
                @updated="updatedMeetingType",
                @destroy="openDestroyConfirmationModal")
  div(align="center")
    loading(:loading="$store.getters.meetingTypeLoading")
    .light-gray-text.light-text(v-show="!$store.getters.meetingTypeLoading") Sem mais resultados

  confirm-modal(
    id='confirm-destroy-meeting-type'
    title='Excluir Tipo de reunião',
    confirm_text='Sim, excluir'
    confirm_class='btn-danger',
    @confirm-modal-confirm='destroyMeetingType'
  )
    br
    div.text-center
      div Confirma exclusão do Tipo de reunião abaixo?
      br
      strong.dark-red-color {{ selected_meeting_type.title }}
      br
      br
</template>

<script>
  import helpers from '../../helpers.coffee'

  const view_model = {
    components: {
      listItem: require('./list_item.vue'),
      newMeetingType : require('./new.vue'),
      noShowFlow : require('./no_show_flow.vue')
    },
    data() {
      return {
        title: '',
        editing: null,
        selected_meeting_type: {}
      }
    },

    methods: {
      loadMeetingTypes() {
        if(this.$store.getters.meetingTypesCount == 0){
          this.$store.dispatch('fetchMeetingTypes')
        }
      },

      toggleEditClass(id) {
        if (this.editing && (this.editing.id === id)) {
          return ''
        } else {
          return 'hidden'
        }
      },

      updatedMeetingType(meeting_type) {
        const index = this.meeting_types.findIndex(meeting_type.id)
        this.meeting_types.replaceById(meeting_type)
      },

      createdMeetingType(meeting_type) {
        this.meeting_types.unshift(meeting_type)
      },

      openDestroyConfirmationModal(meeting_type) {
        this.selected_meeting_type = meeting_type
        EventsBus.$emit('confirm-modal-show', {id: 'confirm-destroy-meeting-type'})
      },

      destroyMeetingType() {
        this.$store.dispatch('removeMeetingType', {id: this.selected_meeting_type.id})
      }
    },

    beforeCreate() {
      if (Session.current_user.isSeller() || Session.current_user.isMonitoringManager()) {
        return this.$router.push('/configuracoes/perfil')
      }
    },

    created() {
      return this.loadMeetingTypes()
    }
  }

  exports.default = helpers.vue_include(view_model, helpers.form)
</script>


<style lang="sass">
#meeting-type
  @import "../../assets/stylesheets/_variables.sass"

  input.form-control
    height: 38px

  .table-col:first-child
    padding-left: 20px

</style>



// WEBPACK FOOTER //
// index.vue?3c7cb29c